import Api from './api';

const customInvoiceRequest = (carId) => {
    const access_token = JSON.parse(localStorage.getItem("jwt"))
    return Api().get('/api/custom/invoice/' + carId , {
        headers: { Authorization: 'Bearer ' + access_token } ,
    })
}

const deleteCustomInvoiceRequest = (id) => {
    const access_token = JSON.parse(localStorage.getItem("jwt"))
    return Api().delete('/api/custom/invoice/' + id, { headers:
        {
            Authorization: 'Bearer ' + access_token,
            'Content-Type': 'application/x-www-form-urlencoded'
        }

    })
}

const customInvoiceExportInPDFRequest = (invoiceId) => {
    const access_token = JSON.parse(localStorage.getItem("jwt"))
    return Api().get('/api/custom/invoice/pdf/' + invoiceId, {
        headers: { Authorization: 'Bearer ' + access_token },
        responseType: 'blob',
    })
}

const customInvoiceExportInEXCELRequest = (invoiceId) => {
    const access_token = JSON.parse(localStorage.getItem("jwt"))
    return Api().get('/api/custom/invoice/excel/' + invoiceId, {
        headers: { Authorization: 'Bearer ' + access_token },
        responseType: 'blob',
    })
}

const updateCustomInvoiceRequest = (data) => {
    const access_token = JSON.parse(localStorage.getItem("jwt"))
        return Api().put('/api/custom/invoice/' + data.id , data, { headers: { Authorization: 'Bearer ' + access_token } })
}

const checkCustomInvoiceRequirements = (carId) => {
    const access_token = JSON.parse(localStorage.getItem("jwt"))
    return Api().get('/api/custom/invoice/check/' + carId , {
        headers: { Authorization: 'Bearer ' + access_token } ,
    })
}
const createNewCustomInvoice = (query) => {
    const access_token = JSON.parse(localStorage.getItem("jwt"))
    return Api().post('/api/custom/invoice/', query , {
        headers: { Authorization: 'Bearer ' + access_token } ,
    })
}



export default {
    deleteCustomInvoiceRequest,
    customInvoiceRequest,
    customInvoiceExportInPDFRequest,
    updateCustomInvoiceRequest,
    customInvoiceExportInEXCELRequest,
    checkCustomInvoiceRequirements,
    createNewCustomInvoice
}



// WEBPACK FOOTER //
// ./src/api/apiCustomInvoices.js